import { defineComponent, ref, computed } from "vue";
import { LAYOUT } from "../../../constants/render.mjs";
import { useBasicStore } from "../../../stores/basic.mjs";
import { useRoomStore } from "../../../stores/room.mjs";
import { storeToRefs } from "pinia";
import { useI18n } from "../../../locales/index.mjs";
import { IconButtonLayout } from "../../../constants/room.mjs";
import IconButton from "../../common/base/IconButton.vue.mjs";
import LayoutIcon from "../../common/icons/LayoutIcon.vue.mjs";
import "../../../directives/vClickOutside.mjs";
import "../../../services/main.mjs";
import { roomService } from "../../../services/roomService.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../../utils/environment.mjs";
import "mitt";
import "../../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "LayoutControl",
  setup(__props) {
    const { t } = useI18n();
    const basicStore = useBasicStore();
    const { layout } = storeToRefs(basicStore);
    const roomStore = useRoomStore();
    const { streamNumber } = storeToRefs(roomStore);
    const showLayoutList = ref(false);
    const isStreamNumberLessThanTwo = computed(() => streamNumber.value < 2);
    const layoutControlConfig = roomService.getComponentConfig("LayoutControl");
    function handleClick(layout2) {
      basicStore.setLayout(layout2);
    }
    function handleClickLayoutIcon() {
      if (isStreamNumberLessThanTwo.value) {
        return;
      }
      showLayoutList.value = !showLayoutList.value;
    }
    function handleClickOutSide() {
      if (showLayoutList.value) {
        showLayoutList.value = false;
      }
    }
    return { __sfc: true, t, basicStore, layout, roomStore, streamNumber, showLayoutList, isStreamNumberLessThanTwo, layoutControlConfig, handleClick, handleClickLayoutIcon, handleClickOutSide, LAYOUT, IconButtonLayout, IconButton, LayoutIcon };
  }
});
export {
  _sfc_main as default
};
